export const ASSISTANT_SHELL_STATE_EVENT = 'triedge:assistant-shell-state';
export const ASSISTANT_OVERLAY_REQUEST_CLOSE_EVENT = 'triedge:assistant-overlay-request-close';

export type AssistantShellStateSource = 'app-shell' | 'parent-app-shell';

export type AssistantShellStateDetail = {
  expanded: boolean;
  source: AssistantShellStateSource;
  timestamp: number;
};

export type AssistantOverlayRequestCloseDetail = {
  source: 'ai-overlay';
  timestamp: number;
};

export const emitAssistantShellState = (detail: Omit<AssistantShellStateDetail, 'timestamp'>): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<AssistantShellStateDetail>(ASSISTANT_SHELL_STATE_EVENT, {
    detail: {
      ...detail,
      timestamp: Date.now(),
    },
  }));
};

export const emitAssistantOverlayRequestClose = (): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<AssistantOverlayRequestCloseDetail>(ASSISTANT_OVERLAY_REQUEST_CLOSE_EVENT, {
      detail: {
        source: 'ai-overlay',
        timestamp: Date.now(),
      },
    })
  );
};
